import React from 'react';
import { evaluateConditions } from '../../Commercial/utils';
import InputByTypeBackoffice from './parts/InputByTypeBackoffice';
import InputPrivacy from '../../../common/componentsV2/inputs/InputPrivacy';
import { greeniaPrivacyPolicy } from '../../../services/axios-client/axeCommons';
import { SurfaceCardHeading } from '../../../common/formInputsV2/Card.styles';

function BackOfficePersonalDataStep({
  errors,
  isValid,
  register,
  setValue,
  control,
  watch,
  formData,
  dataPrivacy,
  privacyItemChangeHandler,
  showPrivacyErrors = false,
}) {
  const stepInputs = [
    {
      name: 'company_name',
      label: 'Ragione Sociale',
      placeholder: '-Ragione Sociale-',
      type: 'text',
      className: 'col-12 col-md-12',
      condition: [{ type: 'eq', field: 'gender', value: 'G' }],
    },
    {
      name: 'email',
      label: 'Email',
      placeholder: 'nome@esempio.it',
      type: 'text',
      className: 'col-12 col-md-12',
      inputType: 'email',
    },
    {
      name: 'phone',
      label: 'Telefono',
      placeholder: 'Es. 3401234567',
      type: 'text',
      className: 'col-12 col-md-12',
      inputType: 'tel',
    },
  ];

  return (
    <div className="row mt-4">
      {stepInputs.map(
        (input) => evaluateConditions(input.condition, watch) && (
          <div className={input.className} key={input.name}>
            <InputByTypeBackoffice
              input={input}
              register={register}
              errors={errors}
              isValid={isValid}
              setValue={setValue}
              control={control}
              watch={watch}
            />
          </div>
        ),
      )}

      <div className="col-12 col-md-12 mt-4">
        <div className="terms">
          <SurfaceCardHeading>Informativa Privacy e IVASS</SurfaceCardHeading>

          <div className="text-decoration-underline mt-1 mb-2">
            <a
              onClick={() => greeniaPrivacyPolicy()}
              style={{ cursor: 'pointer' }}
            >
              <small>Greenia Privacy Policy</small>
            </a>
          </div>
          {dataPrivacy.map((privacy, i) => (
            <InputPrivacy
              required={privacy.required}
              label={privacy.content}
              name={privacy.type}
              id={privacy.type}
              key={i}
              checked={formData?.privacies?.includes(privacy.id)}
              hasError={showPrivacyErrors && privacy.required === 1 && !formData?.privacies?.includes(privacy.id)}
              onChange={(value) => privacyItemChangeHandler(value, privacy)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default BackOfficePersonalDataStep;
